import { render, staticRenderFns } from "./ConfigTable.vue?vue&type=template&id=337c16f0"
import script from "./ConfigTable.vue?vue&type=script&lang=js"
export * from "./ConfigTable.vue?vue&type=script&lang=js"
import style0 from "./ConfigTable.vue?vue&type=style&index=0&id=337c16f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports